import styled from "styled-components";

export const Container = styled.div`
  height: 100vh;
  .declaim-img {
    height: 26px;
    width: 100%;
  }

  .share-img {
    width: 20px;
    width: 20px;
    vertical-align: middle;
  }

  .declaim-img-footer {
    height: 26px;
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 10px;
  }

  .main-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }

  .page-body {
    height: calc(100vh - 44px);
    padding-top: 44px;
    .page-content {
      width: 100%;
      height: 100%;
      position: relative;
    }
  }
  .hide-header {
    padding-top: 0;
    height: 100vh;
  }
  .scroll-container::-webkit-scrollbar {
    display: none;
  }
  .scroll-container::-webkit-scrollbar {
    display: none;
  }
`;

export const DownWrap = styled.div`
position: relative;
width: 348px;
height: 250.5px;
.modal-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
.modal-content {
  padding: 67.5px 30px 0px;
  box-sizing: border-box;
  color: #FFE1C9;
  font-weight: 400;
  z-index: 10;
  position: relative;
  .modal-title {
    font-size: 24px;
    line-height: 24px;
    text-align: center;
    margin-bottom: 17px;
  }
  .modal-tip {
    font-size: 18px;
    line-height: 18px;
  }

  .exit-title {
    margin-bottom: 10px;
  }
}
.modal-btn-wrap {
  display: flex;
  justify-content: space-around;
  margin-top: 22.5px;
  padding: 0 20px;
  .modal-btn-box {
    width: 132.5px;
    height: 44px;
  }
}
.exit-btn-wrap {
  margin-top: 10px;
}
.tool-tip {
  font-size: 17px;
  font-weight: 400;
  color: #FDD9BD;
  line-height: 26px;
}
.exit-tip {
  line-height: 23px;
}
.modal-btn-confirm {
  width: 114px;
  height: 46px;
}
`;


// WEBPACK FOOTER //
// ./src/views/activity_31/style.js